import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useBandContext } from "Bands/contexts";
import {
  bandInfoBlockItemsSelector,
  dataMetaSelector,
  dispatchGetInfoBlockItemsAction,
} from "Bands/state";
import { BAND_ACTIONS } from "Bands/types";
import {
  getInfoBlockItemKey,
  useClearActionMetaOnUnMount,
  usePagination,
} from "Bands/utils";
import { IInfoBlockItem } from "shared/types";

export const useGetInfoBlockItems = (type: IInfoBlockItem) => {
  const { bandId } = useBandContext();

  // state
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.getInfoBlockItems)
  );
  useClearActionMetaOnUnMount(BAND_ACTIONS.getInfoBlockItems);

  // pagination
  const paginationKey = useMemo(
    () => (bandId ? getInfoBlockItemKey(bandId, type) : ""),
    [bandId, type]
  );
  const pagination = usePagination(paginationKey);

  // items
  const itemsSelector = useMemo(
    () => bandInfoBlockItemsSelector(type, pagination),
    [type, pagination]
  );
  const items = useSelector(itemsSelector);

  const fetchItems = useCallback(
    (page?: number) => {
      bandId &&
        dispatchGetInfoBlockItemsAction(dispatch, {
          bandId,
          type,
          page,
        });
    },
    [dispatch, type, bandId]
  );

  // effects
  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  return { apiMeta, items, pagination, fetchItems };
};
